<template>
  <div
    class="bg-white rounded-md shadow-md flex flex-row p-2 relative overflow-hidden group select-none"
  >
    <div
      class="absolute w-full h-full backdrop-filter backdrop-blur-sm z-30 -m-2 opacity-0 group-hover:opacity-100 transition-all flex flex-row content-center justify-center items-center space-x-4"
    >
      <div
        class="bg-blue-600 text-white rounded-full w-10 h-10 inline-flex items-center content-center justify-center cursor-pointer hover:bg-blue-500"
        v-on:click="reprocessYouTube(video.id)"
        v-if="video.youtube_id == null"
      >
        <i class="fa-solid fa-upload"></i>
      </div>
      <div
        class="bg-blue-600 text-white rounded-full w-10 h-10 inline-flex items-center content-center justify-center cursor-pointer hover:bg-blue-500"
        v-on:click="editVideo(video)"
      >
        <i class="fa-solid fa-pen"></i>
      </div>
      <div
        class="bg-blue-600 text-white rounded-full w-10 h-10 inline-flex items-center content-center justify-center cursor-pointer hover:bg-blue-500"
        v-on:click="downloadVideo(video.id)"
      >
        <i class="fa-solid fa-download"></i>
      </div>
      <div class="absolute top-0 right-0 ">
        <i
          class="fa-solid fa-circle-exclamation text-red-600 mt-3 mr-2 z-50 bg-white rounded-full"
          :title="'Embargo: ' + video.embargo"
          v-tippy
          v-if="video.embargo"
        ></i>
      </div>
    </div>
    <div
      class="flex-none flex flex-col items-center content-center w-48 relative"
    >
      <div
        class="absolute top-0 left-0 mt-2 ml-2 bg-blue-500 rounded-md text-white z-20 text-xs px-1.5 py-0.5"
      >
        {{ video.length | timecode }}
      </div>
      <progressive-img
        class="rounded-md z-0"
        fallback="/static/image-unavailable.png"
        :src="video.thumbnailUrl"
      />
      <StarRating
        class="absolute bottom-0 left-0 mb-1 ml-2 z-20"
        :id="video.id"
        :rating="video.rating"
        v-if="video.rating !== null"
      />
    </div>
    <div
      class="flex-1 flex flex-col pl-2 whitespace-nowrap overflow-ellipsis overflow-hidden relative"
    >
      <p class="whitespace-nowrap overflow-ellipsis overflow-hidden">
        <strong class="text-red-600" v-if="video.youtube_id == null"
          >** YOUTUBE PREVIEW MISSING **</strong
        >
        <strong class="text-red-600" v-if="video.status == 'pending'"
          >PENDING</strong
        >
        {{ video.title }}
      </p>
      <span v-if="video.status !== 'pending'"
        >Price: ${{ video.price }}<br
      /></span>
      {{ video.created_at | displayLocalDateTime }} <br />
      Stringer: {{ video.user.name }} <br />
      <div
        class="denied-information"
        style="margin-top: 20px;"
        v-if="video.status == 'declined' && video.declined_message !== null"
      >
        <strong style="color: red;">This video was denied.</strong>
        <br />
        <strong>Reason: </strong>
        {{ video.declined_message.message }}
        <br />
        Declined by {{ video.declined_message.reviewer.name }} at
        {{ video.declined_message.created_at | displayLocalDateTime }}.<br />
      </div>
      <div class="absolute top-0 right-0">
        <i
          class="fa-solid fa-circle-exclamation text-red-600"
          v-if="video.embargo"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from "@/components/general/StarRating";

export default {
  props: ["video"],
  components: { StarRating }
};
</script>
